export enum RESET_STATE {
    DELETE_AND_START_OVER = 'deleteAndStartOver',
    LEAVE_AND_DISCARD = 'leaveAndDiscard',
    LEAVE_WITHOUT_CREATING = 'leaveWithoutCreating',
    ABANDON_AND_CREATE = 'abandonAndCreate'
}
